import { atom } from 'recoil';

import { IS_OPEN_INFO_BANNER } from '../constants';

export const AIsOpenInfoBanner = atom<boolean>({
  key: IS_OPEN_INFO_BANNER,
  default: false,
});
